<template>
    <div>
      <van-nav-bar 
      left-text="返回"
            left-arrow
            fixed
            @click-left="goHome"
        style="position:fixed;width:100%">
          <template #title>
            <span>库存查询</span>
          </template>
        </van-nav-bar>
  
      <van-row style="padding-top:60px">
          <van-form ref="checkbox">
            <van-cell-group inset>
              <van-field
                v-model="productId"
                name="品号"
                label="品号"
                placeholder="品号"
                clearable
              >
                <template #button>
                  <van-icon name="scan" size="24" @click="scanProduct" style="font-size:24px"/>
                 
                </template>
              </van-field>
  
              <!--<van-field
                v-model="productName"
                name="品名"
                label="品名"
                disabled 
                placeholder=""
                clearable
              >
              </van-field>-->

              <van-field
                v-model="store.id"
                name="仓库"
                label="仓库"
                placeholder="仓库"
                disabled
                clearable
              >
                <template #button>
                  <van-icon name="delete" size="24" @click="()=> { store = { id:'', name:'' }}" style="font-size:24px"/>
                  <van-icon name="search" size="24" @click="$refs.storeSelectDialog.open()" style="font-size:24px;margin-left:4px;"/>
                </template>
              </van-field>
            </van-cell-group>
          </van-form>
        </van-row>

        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 4px',margin:'4px 20px 0px','font-size':'14px','line-height':'18px'}">查询结果共<span style="color:red;margin:4px">{{list.length}}</span>笔</van-divider>
  
        <van-row style="padding-top:10px">
            <van-list  
              style="overflow: scroll;padding:0 20px;overflow-y: auto;"
              :style="{ height:innerHeight}"
            >
                <van-cell v-for="(item,index) in list" :key="index" title="" style="margin:10px 0" >
                  <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                  <template #label>
                    <div @click="selectItem(item)" >
                      <van-row >
                        <div class="content">
                          <van-col span="24">{{ item.productName }}【{{item.productId}}】</van-col>

                          <van-col span="12" style="margin-top:4px">
                            仓库:{{item.storeName }}
                          </van-col>
                          <van-col span="12" style="margin-top:4px">
                            库位:{{item.storePosition}}
                          </van-col>
                          <van-col span="12" style="margin-top:4px">
                            批号:{{item.batchId }}
                          </van-col>  
                          <van-col span="12" style="margin-top:4px">
                            在库数量:{{item.inStoreCount}}
                          </van-col>
                        </div>
                      </van-row>
                    </div>
                  </template>
              </van-cell>
             
          </van-list>
        </van-row>
  
        <van-row style="padding:15px 2px 10px">
            <van-button round   size="large" type="info" @click="getDetail" style="height:30px;">查询</van-button>
        </van-row>

        <StoresSelectDialog
          isSingle = true
          ref="storeSelectDialog"
          @select="
            (data) => {
              updateStore(data);
              $forceUpdate();
            }
          "
        ></StoresSelectDialog>
    </div>
  </template>
    
    <script>
  import Vue from 'vue'
  import { router }  from '../../../router'
  import qywxUtil from '../../../util/jweixin/index'
  import { query } from '../../../api/wms/storeQuery/index'
  import { Toast,Dialog} from 'vant';
  
  export default {
      components: {
  
      },
      computed: {
      },
      data() {
        return {
          innerHeight:window.innerHeight - 280 + 'px',
          store:{
            id:'',
            name:''
          },
          productId:'',
          productName:'',
          list:[]
        };
      },
      mounted(){

      },
      methods: {
        updateStore(data){
          if(data.id == this.store.id){
            return;
          }

          //初始化数据
          this.store = data;
        },
        getDetail(){
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0 
        });

          query(this.productId,this.store.id).then(res=>{
            Toast.clear();

            if(res.code == 200){
              this.list = res.data;
            }
            else{
              Toast(res.message);
            }
          });
        },
        async scanProduct(){
          if(!qywxUtil.isReady){
            Toast.loading({
              message: '系统加载中...',
              forbidClick: true,
              duration:0
            });

            Toast.clear();
          }

          var scanResult = await this.$sysUtil.scan();

          this.productId = scanResult.split('|')[0];

        },
        goHome(){
          this.$router.push({
            path:'/home',
            query:{
              active:3
            }
          });
        }
      }
    }; 
    </script>
    
  <style scoped>
  .select{
    border:1px solid rgb(255, 56, 30)
  }
  
  .content{
    font-size:14px;
    color:#323233
  }
  </style>

<style lang="less" scoped>
.van-field__label{
  width:3.2em !important;
}
</style>
